'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var noCreateAllowedFor = exports.noCreateAllowedFor = new Set(['categoryOptionCombo']);

exports.default = {
    baseUrl: '/api',
    i18n: {
        sources: new Set(),
        strings: new Set()
    }
};
//# sourceMappingURL=defaultConfig.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/defaultConfig.js
// module id = 210
// module chunks = 0